(function() {
  'use strict';

  function initRingSizeGuide(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rsg-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rsg-panel]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    function selectState(state, focusTab) {
      tabs.forEach(function(tab) {
        var selected = tab.getAttribute('data-rsg-tab') === state;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;

        if (selected && focusTab) {
          tab.focus();
        }
      });

      panels.forEach(function(panel) {
        var selected = panel.getAttribute('data-rsg-panel') === state;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
    }

    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() {
        selectState(tab.getAttribute('data-rsg-tab'), false);
      });

      tab.addEventListener('keydown', function(event) {
        var nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        selectState(tabs[nextIndex].getAttribute('data-rsg-tab'), true);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ring-size-guide]').forEach(initRingSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
